export enum MerchandiseCodes {
    BASIC_MERCHANDISE = '00',
    UN_CODE = "CP",
    DISAGREGATION = "DCRP",
    HAZARDOUS_WASTE = "DP",
    SUBHEADER = "SP",
    TARIFF = "CA",
}